import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import View from "../../../../assets/img/svg/view.svg";
import { OutlinedInput, InputLabel, TextField, InputBase, Checkbox, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel, isWidthDown } from '@material-ui/core';
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom"
import Pagination from "../../../custom/Pagination";
import $ from "jquery";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Multiselect from "multiselect-react-dropdown"
import Vector from '@material-ui/icons/Close';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getIR_ListView, deletemulitiirdocs, downloadmultipleirdocs } from "../../../../actions/InvestigationReportAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import moment from "moment";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { DraftsSharp } from "@material-ui/icons";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
}));

// const ListViewIR = () => {
//     const classes = useStyles();
//     const [isMobile, setisMobile] = React.useState(false);
//     const navigate = useNavigate();
//     const [radio, setRadio] = React.useState('sample');


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
    },
};
class ListViewIR extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            radio: 'sample',
            IR_ListView: [],
            DownDelete: [],
            hide: 0,
            index:1,
            isAccess: false,
            objectkey: [],
            isMore: false,
            searchData: {
                DateFrom: '',
                DateTo: '',
                Investigationtype: "",
                Incidenttype: [],
                PageNumber: 1,
                PageSize: 10,
                SortBy: 'date',
                SortOrder: 'asc'
            },
            projectId: 0,
            incidenttype: [
                "Fatalities",
                "MTC",
                "Gas Leakage",
                "Environmental Damage",
                "Property Damage",
                "LTI",
                "RWC",
                "Oil Spill",
                "FAC",
                "Chemical Spill"
            ],
            incidenttypeList: []

        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isAccess: true }) : this.setState({ isAccess: false })
        this.state.projectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.getSettingsFormat(this.state.projectId)
        this.dataTable(this.state.searchData, this.state.projectId)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getSettingsFormat = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                this.dataTable(this.state.searchData, this.state.projectId);
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Investigation").addClass("d-none");
        $("#Investigation").removeClass("d-block");
        $("#IRL").removeClass("active-color");
        $("#IRT").removeClass("fw-bolder");
    }

    resize1 = () => {
        $("#INVES1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Investigation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Investigation").removeClass("d-none");
        $("#Investigation").addClass("d-block");
        $("#IRL").addClass("active-color");
        $("#IRT").addClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        if (window.innerWidth < 412) {
            this.setState({
                isMore: true
            })
        }
        else {
            this.setState({
                isMore: false
            })
        }
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    dataTable = (data, id) => {
        let ids = "";
        if (data.Incidenttype.length >= 0) {
            for (var i in data.Incidenttype) {
                ids += "&Incidenttype=" + data.Incidenttype[i];
            }
        }
        let apiUrl1 = API.IR_LISTVIEW + "?projectId=" + id + "&DateFrom=" + data.DateFrom + "&DateTo=" + data.DateTo + '&Investigationtype=' + data.Investigationtype + '' + ids + '' + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl1
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "IRLIST_DOCS", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isAccess === false ? false : true }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/investigationreports/addnew")
    };
    handleRadio = (e) => {
        this.state.searchData.Incidenttype = e.target.value;
        this.setState({})
    }
    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/investigationreports/edit")
    };
    handleCheckboxChange = (e, x) => {
        const { DownDelete } = this.state;
        if (DownDelete.length == 0) {
            DownDelete.push(x)
        }
        else {
            if (DownDelete.filter((i) => i == x).length == 1) {
                DownDelete.map((i, ind) => (
                    i == x ?
                        DownDelete.splice(ind, 1)
                        : ""
                ))
            } else {
                DownDelete.push(x)
            }
        }
        this.setState({})
        if (DownDelete.length == 1) {
            localStorage.setItem("IRViewId", DownDelete[0])
            localStorage.setItem("IREditId", DownDelete[0])
        }
        this.state.hide = DownDelete.length;
        this.setState({})
    };
    ViewPage = () => {

        this.props.navigate("/investigationreports/view")

    };
    ViewPage1 = (id) => {
        localStorage.setItem("IRViewId", id)
        this.props.navigate("/investigationreports/view")
    };
    DeleteItem = () => {
        let tempData = [];
        const { DownDelete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemulitiirdocs(DownDelete, this.state.projectId, this.state.UserRole)
        this.state.DownDelete = [];
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);
    }
    deletemulitiirdocs = (data, id, modify) => {
        const { dispatch } = this.props
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }

        let apiUrl = API.IR_LISTVIEW + '/ids?' + ids + '&modify=' + modify
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.hide = 0;
                    this.state.searchData = {
                        DateFrom: '',
                        DateTo: '',
                        Investigationtype: "",
                        Incidenttype: [],
                        PageNumber: 1,
                        PageSize: 10,
                        SortBy: 'date',
                        SortOrder: 'asc'
                    };
                    this.setState({})
                    this.dataTable(this.state.searchData, this.state.projectId)
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });

    };
    onSelectVaues = (e, node) => {
        this.state.searchData.Incidenttype = e
        this.setState({})
    }

    handleInputChange = (e, str) => {
        this.state.searchData[str] = e.target.value;
        this.setState({})
    };
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='date'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.projectId);
    }
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            DateFrom: '',
            DateTo: '',
            Investigationtype: "",
            Incidenttype: [],
            PageNumber: 1,
            PageSize: 10,
            SortBy: 'date',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);
        // dispatch(getIR_ListView(this.state.searchData, this.state.projectId))
    }
    FileDownload() {
        let tempData = [];
        const { DownDelete } = this.state;
        DownDelete.map((a) => {
            if (a.check == true) {
                tempData.push(a)
            }
        })
        if (tempData?.length > 0) {
            this.props.dispatch(downloadmultipleirdocs(tempData))
            this.state.DownDelete = [];
            this.setState({});
            $('input[type=checkbox]').prop('checked', false);
        }
    }
    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.projectId);
    }
    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.projectId);
    }
    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.projectId);

    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INVES" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INVES" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Investigation Reports </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top mb-5" : "ml-auto scroll-hide mb-5"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        this.state.isAccess ? <>
                            <div className="row  border-bottom">
                                <div className="input-group">
                                    <div className="col-3 col-sm-3 border-right text-center pt-3" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${this.state.hide == 1 ? "span-enabled" : "span-disabled"}`} onClick={this.ViewPage}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</span>
                                    </div>

                                    <div className="col-3 col-sm-3 border-right text-center pt-3" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${(this.state.hide && this.state.isAccess == true) == 1 ? "span-enabled" : "span-disabled"}`} onClick={this.EditPage}><img src={Edit} style={{ marginTop: '-4px', opacity: (this.state.hide == 1 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Edit</span>
                                    </div>
                                    <div className="col-3 col-sm-3 border-right text-center pt-3 pl-2" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${(this.state.hide && this.state.isAccess == true) > 0 ? "span-enabled" : "span-disabled"}`} data-target="#deletepopup" disabled={this.state.hide > 0 ? false : true} data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: (this.state.hide > 0 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Delete</span>
                                    </div>

                                    <div className="col-3 col-sm-3 pt-3  text-center pb-3 pl-1" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={` ${classes.button}`} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</span>
                                    </div>

                                </div>
                            </div>
                        </>
                            :
                            <></>
                        :
                        <>
                            {this.state.isAccess ? <>
                                <div className="row  border-bottom">
                                    <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3 d-flex">
                                        <button className={`${classes.button}  pl-3`} onClick={this.ViewPage} disabled={this.state.hide == 1 ? false : true} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.hide == 1 ? '' : '0.5' }}></img>&nbsp;View</button>

                                        <button className={classes.button} onClick={this.EditPage} disabled={(this.state.hide == 1 && this.state.isAccess == true) ? false : true} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: (this.state.hide == 1 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                        <button className={classes.button} data-target="#deletepopup" disabled={(this.state.hide > 0 && this.state.isAccess == true) ? false : true} data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: (this.state.hide > 0 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                        <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                            <button className={classes.button} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</button>
                                        </div>

                                    </div>
                                </div>
                            </>
                                :
                                <></>}
                        </>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Investigation Reports</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ whiteSpace: 'nowrap' }}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="staffTable" className="align-items-center table table-hover product_table">
                                    <thead>
                                        <tr className="">
                                            <th className="align-middle border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right align-middle border-left" width="8%" style={{ minWidth: '70px' }}  onClick={() => this.handleSort('date',1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Date</span></th>
                                            <th className="border-right align-middle Nowrap" width="13%"  onClick={() => this.handleSort('investigationtype',2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Investigation Type</span></th>
                                            <th className="border-right align-middle Nowrap" width="13%"  onClick={() => this.handleSort('incidenttype',3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Incident Type</span></th>
                                            <th className="border-right align-middle" width="25%" style={{ minWidth: window.innerWidth < 1000 ? '300px' : "" }} onClick={() => this.handleSort('description',4)}><span className="spandoc-thead" style={{ color: "#000000" }}>Description</span></th>
                                            <th className="border-right align-middle" width="25%" onClick={() => this.handleSort('documents',5)} ><span className="spandoc-thead" style={{ color: "#000000" }}>Documents</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.IR_ListView?.Investigation && this.props.IR_ListView?.Investigation?.length > 0 && this.props.IR_ListView?.Investigation.map((i, v) => (
                                            <>
                                                <tr>
                                                    <td className="spandoc-td align-middle border-left "><input type="checkbox" checked={this.state.DownDelete.filter(r=> r === i.Id).length == 1 ? true : false} style={{ width: "16px", height: "16px" }} onChange={(e) => this.handleCheckboxChange(e, i.Id)} /></td>
                                                    <td className="spandoc-td align-middle border-right border-left">
                                                        {i.Date && moment(i.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    </td>
                                                    <td className="spandoc-td align-middle border-right"><a href="#" onClick={() => this.ViewPage1(i.Id)}>{i.Investigationtype}</a></td>
                                                    <td className="spandoc-td align-middle border-right">{i.Incidenttype.map((item, index) => { return (<li className="list-unstyled p-0 m-0 list-none">{item}</li>) })}</td>
                                                    <td className="spandoc-td align-middle border-right">{i.Description}</td>
                                                    <td className="spandoc-td align-middle border-right"><>
                                                        {i?.Documents && i?.Documents.map((a, ind) => (
                                                            <li className="list-unstyled p-0 m-0 list-none"><a href={a.FileUrl} target="_blank">{a.FileName}</a></li>
                                                        ))}
                                                    </></td>
                                                </tr>

                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade  pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true" style={{ overflowY: "scroll", height: "100%" }}>
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4" >
                                    <form id="myform" >
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.DateFrom && moment(this.state.searchData.DateFrom).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.DateFrom && moment(this.state.searchData.DateFrom).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChange(e, "DateFrom") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.DateTo && moment(this.state.searchData.DateTo).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.DateTo && moment(this.state.searchData.DateTo).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChange(e, "DateTo") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Investigation Type </label></div>
                                            <div className="col-7">
                                                <RadioGroup row aria-label="gender" value={this.state.searchData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth>
                                                    <FormControlLabel value="NearMiss" control={<Radio color="default" />} label="Near Miss" size="small" />
                                                    <FormControlLabel value="Incident" control={<Radio color="default" />} label="Incident" size="small" />
                                                </RadioGroup>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className={this.state.isMobile ? "col-12 m-auto pb-2" : "col-5 m-auto"}>
                                                <label htmlFor="name">Incident Type </label>
                                            </div>
                                            <div className={this.state.isMobile ? "col-12 pb-2" : "col-7"}>
                                                <Multiselect
                                                    isObject={false}
                                                    customCloseIcon={<Vector className="cursorPointer" style={{ width: "18px", height: "18px" }} />}
                                                    // onKeyPressFn={(e) => { this.onSelectVaues(e, "keypress") }}
                                                    onRemove={(e) => { this.onSelectVaues(e, "onremove") }}
                                                    // onSearch={(e) => { this.onSelectVaues(e, "onsearch") }}
                                                    onSelect={(e) => { this.onSelectVaues(e, "onselect") }}
                                                    selectedValues={this.state.searchData.Incidenttype}
                                                    options={this.state.incidenttype}
                                                    style={{
                                                        chips: {
                                                            background: '#F8F8F8',
                                                            color: '#9F9F9F',
                                                            'border-radius': '0px',
                                                            borderColor: "#F8F8F8",
                                                        },
                                                        searchBox: {
                                                            'border-radius': '0px'
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button id="closemodal1" type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`mt-5 ${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.props.IR_ListView?.pagination?.PageCount) || (this.props.IR_ListView?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        IR_ListView: state.IRReducer.IR_ListView || [],
        settings: state.commonReducer.settings || [],

        //projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

ListViewIR.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewIR))
);

